import { Component } from "react"
import "./ValuationBlockedMessage.css"

export default class ValuationBlockedMessage extends Component {
    render() {
        return (
            <div className="valuation-blocked-message">
                <p className="valuation-blocked-message-text">
                    This valuation isn't available. Try searching for another address.
                </p>
            </div>
        )
    }
}
